if (!customElements.get('quickbuy-modal')) {
  class QuickbuyModal extends HTMLElement {
    constructor() {
      super();
      this.activeId = null;
    }
    
    connectedCallback() {
      window.addEventListener('click', (e) => {
        const path = e.composedPath();

        if (path[0]?.tagName?.toLowerCase() === 'quickbuy-modal') {
          this.close();
          return;
        }

        const clickedElement = path.find(el =>
          el instanceof Element && el.hasAttribute?.('data-quickbuy-action')
        );
        if (!clickedElement) return;
        e.preventDefault();

        const {
          quickbuyAction,
          quickbuyId
        } = clickedElement.dataset;

        switch (quickbuyAction) {
          case 'open':
            let template = false;
            template = this.deepQuerySelector(`[data-quickbuy-content="${quickbuyId}"]`);
          
            if (!template) return;
  
            const direction = template.dataset?.direction ?? 'left';
            this.classList.add('center');

            if (this.activeId !== quickbuyId) {
              this.activeId = quickbuyId;
              const content = template.content.cloneNode(true);
              this.replaceChildren(content);
            }

            new CustomEvent('quickbuy:product-viewed', {});
            ///REMOVE when quickbuy A/B is over
            window.igEvents = window.igEvents || [];
            window.igEvents.push({"event": "Quickbuy Opened"});

            this.classList.remove('!hidden');
            document.body.classList.add('overlay');
            setTimeout(() => {
              this.classList.remove(
                '-translate-x-full',
                'md:translate-x-full',
                '[&.center]:translate-x-0',
                '[&.center]:translate-y-full'
              );
            }, 10);
            this.querySelector('[data-quickbuy-action="close"]')?.focus();
            trapFocusInDialog(this);
            break;

          case 'close':
            this.close();
            const button = this.deepQuerySelector(`[data-quickbuy-id="${quickbuyId}"]`);
            button.focus();
            break;
        }
      });
    }


    close(keepOverlay) {
      this.classList.add('-translate-x-full', 'md:translate-x-full', '[&.center]:translate-x-0', '[&.center]:translate-y-full');      
      setTimeout(() => {
        this.classList.add('!hidden');
        if (!keepOverlay) document.body.classList.remove('overlay', 'overlay-fadeout');
      }, 500);
    }

    deepQuerySelector(selector, root = document) {
      const walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_ELEMENT,
        {
          acceptNode: () => NodeFilter.FILTER_ACCEPT
        },
        false
      );
      while (walker.nextNode()) {
        const node = walker.currentNode;
        if (node.matches(selector)) {
          return node;
        }
        if (node.shadowRoot) {
          const result = this.deepQuerySelector(selector, node.shadowRoot);
          if (result) return result;
        }
      }
      return null;
    }
  }
  
  
  customElements.define('quickbuy-modal', QuickbuyModal);
}